import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { APPSETTING } from '../../main';

const PAGE_TITLE: Record<string, string> = {
  '/dashboard': 'Command Console',
  '/settings':  'Settings',
};

const ChiefAppLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [showProfile, setShowProfile] = useState(false);
  const [zohoStatus, setZohoStatus]   = useState<'connected' | 'demo' | 'loading'>('loading');

  const userDataString = localStorage.getItem(APPSETTING.appname + 'user');
  const userData  = userDataString ? JSON.parse(userDataString) : null;
  const useremail = userData?.user?.email || 'User';

  useEffect(() => {
    const token = userData?.user?.token;
    if (!token) { setZohoStatus('demo'); return; }
    fetch('/chiefofstaffstatus', { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => setZohoStatus(d.zoho === 'connected' ? 'connected' : 'demo'))
      .catch(() => setZohoStatus('demo'));
  }, []);

  const pageTitle = PAGE_TITLE[pathname] ?? 'Chief of Staff';

  const handleLogout = () => {
    localStorage.setItem(APPSETTING.appname + 'user', null);
    navigate('/login');
  };

  const navItems = [
    { url: '/dashboard', label: 'Chat' },
    { url: '/settings',  label: 'Settings' },
  ];

  return (
    <div className="chief-dash">

      {/* ── Sidebar ── */}
      <aside className="chief-sidebar">
        <div className="chief-sidebar-brand">
          <span className="brand-dot" />
          Chief of Staff
        </div>

        <div className="chief-sidebar-label">Connectors</div>

        <div className="chief-conn-pill">
          <span className={`conn-dot ${zohoStatus === 'connected' ? 'active' : zohoStatus === 'loading' ? 'off' : 'demo'}`} />
          <span className="conn-label">Zoho Books</span>
          <span className="conn-mode">{zohoStatus === 'connected' ? 'Live' : zohoStatus === 'loading' ? '…' : 'Demo'}</span>
        </div>
        <div className="chief-conn-pill">
          <span className="conn-dot demo" />
          <span className="conn-label">Meta Ads</span>
          <span className="conn-mode">Demo</span>
        </div>
        <div className="chief-conn-pill">
          <span className="conn-dot demo" />
          <span className="conn-label">Shopify</span>
          <span className="conn-mode">Demo</span>
        </div>

        <div className="chief-sidebar-label">Navigation</div>

        {navItems.map(item => (
          <div
            key={item.url}
            className={`chief-nav-item ${pathname === item.url ? 'active' : ''}`}
            onClick={() => navigate(item.url)}
          >
            {item.label}
          </div>
        ))}
      </aside>

      {/* ── Main ── */}
      <div className="chief-dash-main">
        <header className="chief-topbar">
          <span className="chief-topbar-title">{pageTitle}</span>

          <div className="chief-profile-wrap">
            <button
              className="chief-profile-btn"
              onClick={() => setShowProfile(p => !p)}
              aria-label="Profile menu"
            >
              {useremail[0].toUpperCase()}
            </button>

            {showProfile && (
              <div className="chief-profile-menu">
                <div className="chief-profile-email">{useremail}</div>
                <button
                  className="btn-gold"
                  style={{ width: '100%', fontSize: '12px', padding: '8px' }}
                  onClick={handleLogout}
                >
                  Sign out
                </button>
              </div>
            )}
          </div>
        </header>

        {/* Content — flex column so Dashboard can fill remaining height */}
        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <Outlet />
        </div>
      </div>

    </div>
  );
};

export default ChiefAppLayout;
